export const id = (prefix = 'id') => `${prefix}-${Math.random().toString(36).substring(2, 9)}`;
